import {Dispatch, FC, useCallback} from 'react';
import EditableField from '../common/fields/EditableField';
import permissionsInfo from '../../constants/permissionsInfo';
import EnsurePermission from '../common/EnsurePermission';
import {doctorValidationSchema} from '../../constants/validationSchemes';
import {DoctorListProps} from '../../constants/types';
import {DoctorToDeleteProps} from './index';
import {useTranslation} from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

type DoctorRowProps = {
  doctor: DoctorListProps,
  editHandler: (id?: number, data?: any) => any,
  handleToggleAddForm: () => void,
  setDoctorToDelete: Dispatch<DoctorToDeleteProps>
};

const Row: FC<DoctorRowProps> = ({
  doctor,
  editHandler,
  handleToggleAddForm,
  setDoctorToDelete
}) => {
  const {t} = useTranslation('doctors');
  const {id, lastName, firstName, externalId} = doctor;

  const cellItem = {
    rowId: id,
    editHandler,
    permission: permissionsInfo.doctors.edit,
    editModeToggleCallback: handleToggleAddForm
  };

  const handleDelete = useCallback(() => {
    setDoctorToDelete({
      id,
      message: t('popup.deleteMessage', {firstName, lastName})
    });
    handleToggleAddForm();
  }, [id, firstName, lastName]);

  return (
    <tr className="row">
      <td className="cell">{id}</td>
      <td className="cell">
        <EditableField
          validationSchema={doctorValidationSchema}
          cellItem={{...cellItem, cellData: {lastName}}}/>
      </td>
      <td className="cell">
        <EditableField
          validationSchema={doctorValidationSchema}
          cellItem={{...cellItem, cellData: {firstName}}}/>
      </td>
      <td className="cell">
        <EditableField
          validationSchema={doctorValidationSchema}
          cellItem={{...cellItem, cellData: {externalId}}}/>
      </td>
      <EnsurePermission elementPermissions={permissionsInfo.doctors.delete}>
        <td className="cell narrow-cell">
          <IconButton
            className="icon-button gray small"
            onClick={handleDelete}
          >
            <DeleteIcon className="icon" />
          </IconButton>
        </td>
      </EnsurePermission>
    </tr>
  );
};

export default Row;
